import { createSelector } from 'reselect';
import type { RootState } from 'typesafe-actions';
import type { ProviderPlanListState } from './reducer';
import { GradeMemberRank, MemberBenefit } from 'favoriteList/constants/favoriteLists';
import { replaceFeatureName, removeFeatureGroup } from 'favoriteList/constants/filters';
import memoize from '@travel/traveler-core/utils/memoize';

export const getProviderPlan = (state: RootState) => state.providerPlan;

export const getIsProviderFetching = createSelector(
  getProviderPlan,
  (state: ProviderPlanListState) => state.isProviderFetching,
);
export const getIsFavoriteHandlerSuccess = createSelector(
  getProviderPlan,
  (state: ProviderPlanListState) => state.isFavoriteHandlerSuccess,
);
export const getIsPlanFetching = createSelector(
  getProviderPlan,
  (state: ProviderPlanListState) => state.isPlanFetching,
);
export const getIsProviderFetchingMore = createSelector(
  getProviderPlan,
  (state: ProviderPlanListState) => state.isProviderFetchingMore,
);
export const getIsPlanFetchingMore = createSelector(
  getProviderPlan,
  (state: ProviderPlanListState) => state.isPlanFetchingMore,
);
export const getProviderList = createSelector(
  getProviderPlan,
  (state: ProviderPlanListState) => state.providerList,
);
export const getPlanList = createSelector(
  getProviderPlan,
  (state: ProviderPlanListState) => state.planList,
);
export const getDraftProvider = createSelector(
  getProviderPlan,
  (state: ProviderPlanListState) => state.draftProvider,
);
export const getDraftPlan = createSelector(
  getProviderPlan,
  (state: ProviderPlanListState) => state.draftPlan,
);
export const getProviderDataCount = createSelector(
  getProviderPlan,
  (state: ProviderPlanListState) => state.providerDataCount,
);
export const getPlanDataCount = createSelector(
  getProviderPlan,
  (state: ProviderPlanListState) => state.planDataCount,
);
export const getFilter = memoize((memberRank?: string) =>
  createSelector(getProviderPlan, (state: ProviderPlanListState) => {
    if (memberRank === GradeMemberRank.DIAMOND_RANK_MEMBER) {
      return replaceFeatureName(
        state.filter,
        MemberBenefit.MEMBER_BENEFIT,
        MemberBenefit.DIAMOND_RANK_MEMBER_BENEFIT,
      );
    } else if (memberRank === GradeMemberRank.PLATINUM_RANK_MEMBER) {
      return replaceFeatureName(
        state.filter,
        MemberBenefit.MEMBER_BENEFIT,
        MemberBenefit.PLATINUM_RANK_MEMBER_BENEFIT,
      );
    } else {
      return removeFeatureGroup(state.filter, MemberBenefit.MEMBER_BENEFIT);
    }
  }),
);
